import { Select } from '@clientbase/clientbase-library'
import { Box, MenuItem } from '@mui/material'
import { useAuthContext } from 'context/AuthContext'

import MerchantBadge from 'components/MerchantBadge'

type CompanySelectorProps = {
  value?: string
  onChange: (merchantUuid: string) => void
  disabled?: boolean
}

/**
 * SC-10999: seletor "Empresa" dos formulários de criação. Só aparece na visão
 * multi-empresas; fora dela não renderiza nada.
 */
const CompanySelector = ({
  value,
  onChange,
  disabled
}: CompanySelectorProps) => {
  const { groupSession } = useAuthContext()

  if (!groupSession || !value) return null

  const merchants = groupSession.merchants

  return (
    <Box mb={2}>
      <Select
        fullWidth
        label="Empresa"
        name="company"
        value={value}
        disabled={disabled}
        onChange={(event) => {
          const next = String(event.target.value)
          if (next && next !== value) onChange(next)
        }}
        renderValue={(selected) => {
          const merchant = merchants.find(
            ({ merchant_uuid }) => merchant_uuid === selected
          )
          return (
            <MerchantBadge
              name={merchant?.name}
              logoUrl={merchant?.logo_url}
              size={22}
            />
          )
        }}
      >
        {merchants.map((merchant) => (
          <MenuItem key={merchant.merchant_uuid} value={merchant.merchant_uuid}>
            <MerchantBadge
              name={merchant.name}
              logoUrl={merchant.logo_url}
              size={22}
            />
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}

export default CompanySelector
